import React from "react";
import WideSidebar from "./WideSidebar";

const WidePageSection = ({ children, className }) => (
  <div className={`pageWithSidebar${className ? ` ${className}` : ""}`}>
    <div className="pageMain">{children}</div>
    <WideSidebar />
  </div>
);

export default WidePageSection;
